// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__238-y","list":"BalanceDue_list__23Kt0","listRow":"BalanceDue_listRow__2cJ2F","total":"BalanceDue_total__3xy-j"};